module.exports = __webpack_public_path__ + "img/aixue.6e473487.png";